<div *ngIf="isLoading">
  <app-loader></app-loader>
</div>
<div class="modal-dialog">
  <div class="modal-content p-3">
    <div class="row">
      <!-- Profile Picture -->
      <div class="profile-circle mb-2">{{ userInitials }}</div>

      <!-- User Information -->
      <div class="col-6" style="margin-top: 5px">
        <h5 class="mb-0 font-weight-bold">{{ userName }}</h5>
        <p class="mb-0">{{ userEmail }}</p>
        <small>{{ selectedPrimaryCompanyValue }}</small>
      </div>
    </div>

    <hr />

    <!-- Focused Regions Dropdown -->
    <div class="mb-3" *ngIf="!isMTXUser">
      <div *ngIf="primaryCompanyValues.length > 1">
        <label
          for="regionSelect"
          class="form-label font-weight-bold text-primary"
          >Focused Primary Company</label
        >

        <select
          id="pcSelect"
          class="form-select"
          [(ngModel)]="selectedPrimaryCompanyValue"
          (change)="onPrimaryCompanyValueChange($event)"
        >
          <option *ngFor="let value of primaryCompanyValues" [value]="value">
            {{ value }}
          </option>
        </select>
      </div>

      <label for="regionSelect" class="form-label font-weight-bold text-primary"
        >Focused {{ level3Name }}</label
      >

      <select
        id="regionSelect"
        class="form-select"
        [(ngModel)]="selectedLevel3Value"
        (change)="onLevel3ValueChange($event)"
      >
        <option *ngFor="let value of level3Values" [value]="value">
          {{ value }}
        </option>
      </select>
    </div>

    <div class="mb-3" *ngIf="isMTXUser">
      <label
        for="primaryCompanySelect"
        class="form-label font-weight-bold text-primary"
        >Focused Primary Company</label
      >

      <select
        id="primaryCompanySelect"
        class="form-select"
        [(ngModel)]="selectedSyrcPrimaryCompany"
        (change)="onSyrcPrimaryCompanyValueChange()"
      >
        <option *ngFor="let type of syrcPrimaryCompanies" [ngValue]="type">
          {{ type?.name }}
        </option>
      </select>
    </div>

    <!-- Menu Items -->
    <ul class="list-unstyled mb-0">
      <li
        *ngIf="isMTXUser"
        class="mb-2 d-flex align-items-center"
        (click)="ManageMobiltexMemberClicked()"
      >
        <mat-icon>group_add</mat-icon>
        <span class="ml-2" style="margin-left: 10px"
          >Manage Mobiltex Member</span
        >
      </li>
      <!-- <li class="mb-2 d-flex align-items-center">
        <mat-icon>lock</mat-icon>
        <span class="ml-2" style="margin-left: 10px">Change Password</span>
      </li> -->
      <li class="d-flex align-items-center" (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span class="ml-2" style="margin-left: 10px">Logout</span>
      </li>

      <li>
        <label class="font-weight-bold text-end d-block" style="font-size: 14px; line-height: 4px;" >{{environmentName + ' ' + versionNumber}}</label>
      </li>
    </ul>
  </div>
</div>
